import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
    selector: '[clickSelect]'
})
export class ClickSelectDirective {
    constructor(private el: ElementRef<HTMLInputElement>) {}

    @HostListener('click')
    onClick() {
        const input = this.el.nativeElement;
        input.select();
    }
}
